// @flow
import styled from '@emotion/styled'
import transparentize from 'polished/lib/color/transparentize'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { Select } from '../form/Select'
import * as Responsive from '../responsive'
import { defaultText } from '../text'

type Props = {
  activeTab: string,
  onChangeTab: (tabId: string) => void,
  tabs: $ReadOnlyArray<{
    id: string,
    title: string,
    sections: Array<{
      title: string,
      content: React.Node,
    }>,
  }>,
}

export function Wrapper({ tabs, activeTab, onChangeTab }: Props) {
  const onTabSelected = (id) => {
    onChangeTab(id)
  }

  return (
    <React.Fragment>
      <Responsive.MobileOnly>
        <Select
          id="test"
          name="test"
          onChange={(evt: SyntheticInputEvent<HTMLSelectElement>) =>
            onTabSelected(evt.currentTarget.value)
          }
          label=""
        >
          {tabs.map(({ id, title }) => (
            <option key={id} value={id}>
              {title}
            </option>
          ))}
        </Select>
      </Responsive.MobileOnly>
      <Responsive.DesktopOnly>
        <WrapperRoot>
          {tabs.map(({ id, title }) => (
            <Tab
              active={id === activeTab}
              id={id}
              key={id}
              title={title}
              onSelected={onTabSelected}
            />
          ))}
        </WrapperRoot>
      </Responsive.DesktopOnly>
    </React.Fragment>
  )
}

const WrapperRoot: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 80px;

  background-color: ${colors.almostWhite};
`

type TabProps = {|
  +active: boolean,
  +id: string,
  +onSelected: (string) => void,
  +title: string,
|}

export function Tab({ active, id, onSelected, title }: TabProps) {
  return (
    <>
      <TabRootMobile>{title}</TabRootMobile>
      <TabRoot active={active} onClick={() => onSelected(id)}>
        <Title active={active}>{title}</Title>
      </TabRoot>
    </>
  )
}

const TabRoot: React.ComponentType<any> = styled.div`
  flex: 1 auto;
  height: 100%;
  background-color: ${({ active }) =>
    active ? colors.fadedPurpleAlt : colors.almostWhite};
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: ${({ active }) => (active ? 'default' : 'pointer')};

  &:not(:last-child) {
    border-right: 1px solid ${transparentize(0.9, colors.fadedPurpleAlt)};
  }

  &:hover {
    div {
      ${({ active, theme }) =>
        active ? '' : `border-bottom: 1px solid ${theme.primary}`}
    }
  }
`
// TODO: part of another issue
const TabRootMobile: React.ComponentType<any> = styled.option`
  ${media.mq[1]} {
    display: none;
  }
`

const Title: React.ComponentType<any> = styled.div`
  ${defaultText};
  color: ${({ active }) => (active ? colors.almostWhite : colors.darkPurple)};
  padding-bottom: 2px;
  display: none;
  ${media.mq[1]} {
    display: inherit;
  }
`
